import { resolve } from "resolve.exports";
import debug from "debug";
import { getImportableUrlFromAutomergeUrl } from "./urls.js";
const log = debug("patchwork:filesystem");
export const defaultImportConditions = ["patchwork", "browser", "import"];
export async function importModuleFromFolderDocUrl(folderDocUrl, subpath = ".", conditions = defaultImportConditions) {
    log(`Importing module from folder doc url ${folderDocUrl} (subpath: ${subpath})`);
    const entryPointUrl = await packageEntryPointUrl(folderDocUrl, subpath, conditions);
    if (!entryPointUrl) {
        throw new Error(`No entry point found for subpath "${subpath}" in package.json`);
    }
    log(`Importing module from entry point url ${entryPointUrl}`);
    return import(/* @vite-ignore */ entryPointUrl);
}
async function packageJsonContentsFromFolderDocUrl(folderDocUrl) {
    const packageJSONPath = new URL("package.json", new URL(getImportableUrlFromAutomergeUrl(folderDocUrl), window.location.origin)).href;
    const response = await fetch(packageJSONPath);
    if (!response.ok) {
        return undefined;
    }
    return response.json();
}
export function resolvePackageExport(pkgJson, subpath = ".", conditions = defaultImportConditions) {
    try {
        const resolved = resolve(pkgJson, subpath, { conditions });
        if (resolved)
            return resolved[0];
    }
    catch {
        // ignore, fallback to main
    }
    // fallback to main only for the root export
    if (subpath === "." && typeof pkgJson.main === "string") {
        return pkgJson.main;
    }
    throw new Error(`No valid 'exports' for "${subpath}" or 'main' in package.json`);
}
async function packageEntryPointUrl(folderDocUrl, subpath = ".", conditions = defaultImportConditions) {
    const pkgJson = await packageJsonContentsFromFolderDocUrl(folderDocUrl);
    if (!pkgJson)
        return undefined;
    const entryPoint = resolvePackageExport(pkgJson, subpath, conditions);
    if (!entryPoint)
        return undefined;
    // Build the final URL via the URL constructor
    const base = new URL(getImportableUrlFromAutomergeUrl(folderDocUrl), window.location.origin);
    const entry = new URL(entryPoint, base);
    return entry.href;
}
